import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import NewExchInner from "./NewExchInner";
import NewExchInnerTest from "./NewExchInnerTest";

export default function NewExchInnerWrapper() {
  const { eventId } = useParams();
  useEffect(() => {}, [eventId]);
  return <NewExchInnerTest key={`${eventId}`} eventId={eventId} />;
}
